import React, { useEffect, useState } from 'react'
import {
    FacilityBookNowContainer,
    FormContent,
    ColumnContent,
    ReservationTitle,
    BookInfoContent,
    BookInfoTitle,
    ColumnLeftBookInfoContent,
    ColumnRightBookInfoContent,
    BookInfoImage,
    BookInfoData,
    BookInfoDataCourtCol,
    BookInfoDataPriceCol,
    ReservationTotalContent,
    BookInfoTotalTitle,
    BookInfoCardImage,
    PayButtonContent,
    ColumnImgContent,
    CardFormContent,
    RadioButtonInput,
    RadioButtonLabel
} from './FacilityBookNow.styled'
import Breadcrumb from 'components/Breadcrumb'
import { Page, pages } from 'pages/pages'
import CardForm from 'components/CardForm/CardForm'
import Button from 'components/Button/Button'
import { userActions } from 'store/slices/users/users.slice'
import Visa from 'assets/icons/visa.svg'
import Mastercard from 'assets/icons/mastercard.svg'
import Discover from 'assets/icons/discover.svg'
import Amex from 'assets/icons/amex.svg'
import { useAppDispatch, useAppState } from 'store'
import { PaymentMethod } from 'models/payment.model'
import cogoToast from 'cogo-toast';
import { transactionActions } from 'store/slices/transactions/transactions.slice';
import { CreateOnlineReservation } from 'services/transaction/transaction.types';
import { useHistory, useParams } from 'react-router';
import { Location } from 'models/location';
import moment from 'moment';
import { BookingNowData } from 'models/appointment.model';
import Spinner from 'components/Spinner';

const FACILITY_BOOK_NOW_BREADCRUM: Page[] = [pages.Home, pages.FacilityVisitor]
const FacilityBookNow = () => {
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethod[]>([]);
    const [paymentMethodsSelected, setPaymentMethodsSelected] = useState<string>('');
    const { userProfile } = useAppState(state => state.user);
    const { user } = useAppState(state => state.auth);
    const { bookingNowData } = useAppState(state => state.appointments);
    const { createOnlineReservationLoading } = useAppState(state => state.transaction)

    const params = useParams<Location>();
    const { push } = useHistory();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!userProfile && user) {
            dispatch(userActions.getUserProfile(user.id))
        }
        if (userProfile && userProfile.payment_methods.length > 0) {
            const { payment_methods } = userProfile;
            setPaymentMethod(payment_methods);
        }
    }, [userProfile])

    const getFormatedDate = () => {
        let date = '';
        if (bookingNowData && bookingNowData.date) {
            const month = bookingNowData.date.toLocaleString('en', { month: 'long' });
            const day = bookingNowData.date.getDate();
            const year = bookingNowData.date.getFullYear();
            date = `${month} ${day}, ${year}`;
        }
        return date;
    }

    const getCardIcon = (type: string) => {
        switch (type.toLowerCase()) {
            case 'visa': return Visa;
            case 'mastercard': return Mastercard;
            case 'discover': return Discover;
            case 'amex': return Amex;
            default: return '';
        }
    }

    const getPriceInPennies = (price: any) => price !== 0 ? price / 100 : price;

    const getMilitaryHours = (hourData: string) => {
        const hoursInfo = hourData.split(" ");
        const hour = hoursInfo[0].split(":")[0];

        if (hoursInfo[1] === "am") {
            if (hour === '12') { return '00:00:00'; }
            return Number(hour) < 10 ? `0${hour}:00:00` : `${hour}:00:00`;
        } else {
            return hour !== '12' ? `${Number(hour) + 12}:00:00` : '12:00:00';
        }
    }

    const getDateInfoWithFormat = (bookingInfo: BookingNowData | null) => {
        const result = {
            date: '',
            start_time: '',
            end_date: ''
        }
        if (bookingInfo) {
            result.date = moment(bookingInfo.date).format('YYYY-MM-DD');
            result.start_time = `${result.date}T${getMilitaryHours(bookingInfo.start_time)}`
            result.end_date = `${result.date}T${getMilitaryHours(bookingInfo.end_time)}`
        }
        return result;
    }

    const onClickPayHandler = async () => {
        if (paymentMethodsSelected === '') {
            cogoToast.error('Please, select one of the payment methods.', {
                position: 'top-right',
            })
        } else {
            if (params && params.locationId) {
                const locationId = params.locationId;
                const { date, start_time, end_date } = getDateInfoWithFormat(bookingNowData);
                const body: CreateOnlineReservation = {
                    payment: {
                        amount: getPriceInPennies(bookingNowData?.price),
                        subtotal: getPriceInPennies(bookingNowData?.price),
                        description: 'Online appointment payment',
                        payment_method: {
                            payment_method_id: Number(paymentMethodsSelected),
                            payment_token_data: null
                        }
                    },
                    transaction_items: [{
                        transaction_type: 'appointment',
                        date: date,
                        start_date: start_time,
                        end_date: end_date,
                        court_id: bookingNowData?.court_id ? Number(bookingNowData.court_id) : null,
                        notes: ''
                    }]
                }
                await dispatch(
                    transactionActions.createOnlineReservation({
                        locationId,
                        body,
                    })
                ).then((res: any) => {
                    if (!res.payload.error) {
                        push('/profile')
                    }
                })
            }
        }
    }

    return (
        <>
            <FacilityBookNowContainer>
                <Breadcrumb breadcrumbPages={FACILITY_BOOK_NOW_BREADCRUM} pageParam={'1'} />
                {createOnlineReservationLoading === 'loading' ? (
                    <Spinner />
                ) : (
                    <FormContent>
                        <ColumnContent>
                            <ReservationTitle>Reserve your court</ReservationTitle>
                            <BookInfoContent>
                                <BookInfoTitle>{bookingNowData?.location_name}</BookInfoTitle>
                                <ColumnLeftBookInfoContent>
                                    <BookInfoImage src={bookingNowData?.location_logo_url} alt='image_court' />
                                </ColumnLeftBookInfoContent>
                                <ColumnRightBookInfoContent>
                                    <BookInfoData>{getFormatedDate()}</BookInfoData>
                                    <BookInfoData>{bookingNowData?.start_time} - {bookingNowData?.end_time}</BookInfoData>
                                    <BookInfoDataCourtCol>
                                        <BookInfoData>{bookingNowData?.court_name}</BookInfoData>
                                    </BookInfoDataCourtCol>
                                    <BookInfoDataPriceCol>
                                        <BookInfoData>${getPriceInPennies(bookingNowData?.price)}</BookInfoData>
                                    </BookInfoDataPriceCol>
                                </ColumnRightBookInfoContent>
                            </BookInfoContent>
                            <ReservationTotalContent>
                                <BookInfoTotalTitle>Total: ${getPriceInPennies(bookingNowData?.price)}</BookInfoTotalTitle>
                            </ReservationTotalContent>
                        </ColumnContent>
                        <ColumnContent>
                            <form>
                                {paymentMethod && paymentMethod.length > 0 && paymentMethod.map((method, index) => (
                                    <BookInfoContent key={`book-info-${index}`}>
                                        <ColumnContent>
                                            <RadioButtonLabel>
                                                <RadioButtonInput
                                                    type='radio'
                                                    key={`radio-payment-${method.id.toString()}`}
                                                    name='payment'
                                                    value={method.id.toString()}
                                                    onChange={e => e.target.value && setPaymentMethodsSelected(e.target.value)}
                                                />
                                                <span>{[method.name ? method.name : `Credit card ${index}`, `\n**** ${method.card_number}`]}</span>
                                            </RadioButtonLabel>
                                        </ColumnContent>
                                        <ColumnImgContent>
                                            <BookInfoCardImage src={getCardIcon(method.card_type)} alt='image_court' />
                                        </ColumnImgContent>
                                    </BookInfoContent>
                                ))}
                                <BookInfoContent>
                                    <RadioButtonLabel>
                                        <RadioButtonInput
                                            type='radio'
                                            key='new-card'
                                            name='payment'
                                            value='credit-card'
                                            disabled
                                            onChange={e => e.target.value && setPaymentMethodsSelected(e.target.value)}
                                        />
                                        <span>New credit card</span>
                                    </RadioButtonLabel>
                                    <CardFormContent>
                                        <CardForm />
                                    </CardFormContent>
                                </BookInfoContent>
                            </form>
                            <PayButtonContent>
                                <Button
                                    style={{
                                        width: '23%',
                                        position: 'absolute',
                                        bottom: '20px',
                                        right: '20px'
                                    }}
                                    text='Pay'
                                    variant='primary'
                                    preset='filled'
                                    size={'large'}
                                    onClick={onClickPayHandler}
                                />
                            </PayButtonContent>

                        </ColumnContent>
                    </FormContent>
                )}
            </FacilityBookNowContainer>
        </>
    )
}

export default FacilityBookNow;